import { render, staticRenderFns } from "./UserAssignment.vue?vue&type=template&id=387b2298&scoped=true&"
import script from "./UserAssignment.vue?vue&type=script&lang=ts&"
export * from "./UserAssignment.vue?vue&type=script&lang=ts&"
import style0 from "./UserAssignment.vue?vue&type=style&index=0&id=387b2298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b2298",
  null
  
)

export default component.exports